import React from 'react'
import LoaderImg from 'shared/components/LoaderImg/LoaderImg'
import { ReactComponent as BragsheetIcon } from 'assets/icons/contract.svg'
import s from '../../styles/RecommendationsSkeleton.module.scss'

const RecommendationsSkeleton = () => (
	<div className={s.wrap}>
		<div className={s.bragsheetRow}>
			<div className={s.bragsheetLeft}>
				<span className={s.bragsheetIcon}>
					<BragsheetIcon />
				</span>
				<div className={s.titleLoader}>
					<LoaderImg />
				</div>
			</div>
			<div className={s.actionLoader}>
				<LoaderImg />
			</div>
		</div>

		<div className={s.table}>
			<div className={s.tableHeader} />
			{[0, 1, 2].map(key => (
				<div className={s.tableRow} key={key}>
					<div className={s.applicationLoader}>
						<LoaderImg />
					</div>
					<div className={s.statusLoader}>
						<LoaderImg />
					</div>
					<div className={s.countLoader}>
						<LoaderImg />
					</div>
					<div className={s.actionsLoader}>
						<LoaderImg />
					</div>
				</div>
			))}
		</div>
	</div>
)

export default RecommendationsSkeleton
